import { PLAN_PERMISSIONS_NAMES } from "../../redux/modules/auth/userPermissions/selector";
import DEFAULT_DRAWN_OBJECTS_OPTIONS from "../TvChart/defaultDrawnObjectsOptions";
import defaultStudyChartData from "../TradingView/defaultStudyChartData";

/**
 * Merge saved key/value settings onto the default drawn-objects schema (with labels).
 */
export function mergeDrawnObjectsOptions(settings = []) {
  return DEFAULT_DRAWN_OBJECTS_OPTIONS.map(option => {
    const saved = settings.find(item => item.key === option.key);
    const value =
      saved && typeof saved.value !== "undefined" ? saved.value : option.value;

    return { ...option, value };
  });
}

/**
 * Resolve chart JSON to load into the bridge widget (user chart → template → default).
 */
export default function resolveTvChartBridgeSavedChart({
  chartUserData,
  chartTemplatesState,
  hasPermission
}) {
  let payload = chartUserData;

  if (payload && payload.type && typeof payload.payload !== "undefined") {
    payload = payload.payload;
  }

  let drawnObjectsOptions = mergeDrawnObjectsOptions(
    Array.isArray(payload?.settings) ? payload.settings : []
  );
  const backups = Array.isArray(payload?.backups) ? payload.backups : [];

  if (payload && payload.chart) {
    const chart =
      typeof payload.chart === "string"
        ? JSON.parse(payload.chart)
        : payload.chart;

    return {
      savedChart: chart,
      source: "user",
      drawnObjectsOptions,
      backups
    };
  }

  const check =
    typeof hasPermission === "function" ? hasPermission : () => false;
  const canUseDefaultTemplate = !!check([
    PLAN_PERMISSIONS_NAMES.TRADING_VIEW_CHART
  ]);

  if (
    chartTemplatesState?.defaultTemplate?.settings &&
    canUseDefaultTemplate
  ) {
    const settings = chartTemplatesState.defaultTemplate.settings;
    const chart = settings.chart || settings;

    if (Array.isArray(settings.drawnObjectsOptions)) {
      drawnObjectsOptions = mergeDrawnObjectsOptions(
        settings.drawnObjectsOptions
      );
    }

    return {
      savedChart: chart,
      source: "template",
      drawnObjectsOptions,
      backups
    };
  }

  return {
    savedChart: defaultStudyChartData,
    source: "default",
    drawnObjectsOptions,
    backups
  };
}
